<body>
<div class="digital-library">
    <h2><span style="color: brown; font-weight: bold;">Digital Library</span> :: SDP College of Teacher Education, Tihu: Assam</h2>
    <p>Digital Library preserves and enables easy and open access to all types of digital content including text, images, moving images, mpegs, and data sets and make it available to the entire scholarly community in open access.</p>

    <div class="library-buttons">
        <a href="https://sdpctetihu.in/" class="button" target="_blank">More Details</a>
        <a href="https://sdpctetihu.in/" class="button" target="_blank">E-Resources Details</a>
        <a href="#" class="button" target="_blank">Web-OPAC</a>
        <a href="https://www.researchgate.net/" class="button" target="_blank">Research Gate</a>
        <a href="https://libgen.li/" class="button" target="_blank">Lib Gen</a>
        <a href="https://en.booksee.org/" class="button" target="_blank">Book See</a>
        <a href="https://www.gutenberg.org/" class="button" target="_blank">Gutenberg</a>
    </div>
</div>

<div class="text-slide">
    <div class="text-group">
        <p class="textSlide">Welcome to Digital Library, SDP College of Teacher Education, Tihu:Assam </p>
    </div>
</div>

<div class="img-slider">
    <div class="slides">
        <div class="slide">
            <img src="assets/images/main-gate.jpg" alt="MainGate">
        </div>
    </div>
	<!--
    <div class="slide-nav">
        <div class="btn"></div>
        <div class="btn"></div>
    </div>
	-->
</div>

<!--
<div class="img-slider" #slider>
  <div class="slides" [style.transform]="transformStyle">
    <div class="slide" *ngFor="let image of images">
      <img [src]="image.src" [alt]="image.alt" />
    </div>
  </div>
  <div class="slide-nav">
    <div
      class="btn"
      *ngFor="let image of images; let i = index"
      [style.backgroundColor]="i === index ? '#fff' : 'rgba(255,255,255,0.5)'"
      (click)="showSlide(i)"
    ></div>
  </div>
</div>
-->

<div class="logo-slider">
    <div class="logo-group">
        <a href="https://ndl.iitkgp.ac.in/" class="logo"><img src="assets/images/ndli_big.jpg" alt="NDLI Logo"></a>
        <a href="https://epgp.inflibnet.ac.in/" class="logo"><img src="assets/images/e-pathsala.png" alt="E-Pathsala Logo"></a>
        <a href="https://eacharya.inflibnet.ac.in/" class="logo"><img src="assets/images/vidyamitra.png" alt="Vidyamitra Logo"></a>
        <a href="https://nptel.ac.in/" class="logo"><img src="assets/images/nptel-logo.png" alt="NPTEL Logo"></a>
        <a href="https://delnet.in/" class="logo"><img src="assets/images/delnet.jpg" alt="DELNET Logo"></a>
        <a href="https://vle.du.ac.in/" class="logo"><img src="assets/images/du-1.png" alt="DU Logo"></a>
        <a href="https://www.education.gov.in/" class="logo"><img src="assets/images/mhrd.png" alt="MHRD Logo"></a>
    </div>
</div>
</body>
